<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-row>
    <b-col cols="5">
      <span>Selecciona el agrupador</span>
      <br/>
      <br/>
      <div>
        <b-form-radio-group
              v-model="opcionSeleccion"
              :options="lstAgrupadores"
              class="mb-3"
              value-field="id"
              text-field="name"
              disabled-field="notEnabled"
              stacked
              @change="habilitar()"
         ></b-form-radio-group>
      </div>
    </b-col>


    <b-col cols="7">
<!--      lstTratamientosProp.filter(tp => tp.idTratamientoPadre == null)-->
      <ListaFiltraComponente ref="listaFiltroAgrupador"
                             :lista-principal.sync="listaPrincipal"
                              :vistaAgrupador="true"
                              :opcionSeleccion="parseInt(opcionSeleccion)"
                              @listaCheckeada="listaSeleccionadaAgrupador = $event"
                             :selecionado-automatico="false"
                             :placeholderBuscador="opcionSeleccion === 1 ? 'Búsqueda de tratamiento padre'
                                                : opcionSeleccion === 2 ? 'busqueda de categoria'
                                                  : 'búsqueda edad paciente' "
      />
    </b-col>
  </b-row>

  <br/>
  <div class="text-center">
    <b-button variant="info" pill style="margin-right: 60px;" @click="agregarAListaTabla()"> Agregar </b-button>
    <b-button variant="outline-secondary" pill @click="hideModal"> Cancelar </b-button>
  </div>



</div>
</template>

<script>
import ListaFiltraComponente from "@/views/promocionesV2/componentes/listaFiltraComponente";
export default {
  name: "AgrupadorPromos",
  components: {ListaFiltraComponente},
  props:{
    lstTratamientosProp: Array,
    lstCategoriasProp: Array,
    lstEdadPaciente: Array,
    tratamientosPadre: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    opcionSeleccion: 0,
    lstAgrupadores: [
      { id: '1', name: 'Tratamiento Padre' },
      { id: '2', name: 'Categoría' },
      { id: '3', name: 'Edad Paciente' },
    ],
    listaSeleccionadaAgrupador:[],
    tratamientosSeleccionados:[],
    listaTratamientosPadre: [],
    listaTratamientosHijos: [],
    listaPrincipal: [],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  //  this.buscarHijos();
  //  this.$refs.listaFiltroAgrupador.filtrarListaPorCoincidencia();

  },
  methods:{
    habilitar(){

      if (this.opcionSeleccion == 1){
        this.listaPrincipal = JSON.parse(JSON.stringify(this.tratamientosPadre));
      }else if (this.opcionSeleccion == 2) {
        this.listaPrincipal = JSON.parse(JSON.stringify(this.lstCategoriasProp));
      }else if (this.opcionSeleccion == 3 ){
        this.listaPrincipal = JSON.parse(JSON.stringify(this.lstEdadPaciente));
      }

      this.$refs.listaFiltroAgrupador.filtrarListaPorCoincidencia();
    },
  /*  buscarHijos(){
      this.listaTratamientosHijos = this.lstTratamientosProp.filter(t => t.idTratamientoPadre != null);

      let tratamientosPadre = [];
      this.listaTratamientosHijos.forEach(h => {
        this.lstTratamientosProp.forEach(tp => {
          if (h.idTratamientoPadre == tp.idTratamiento){
            tratamientosPadre.push(tp);
          }
        })
      })
      let unicos = Array.from(new Set( tratamientosPadre))
      this.listaTratamientosPadre = unicos;



    },*/
    agregarAListaTabla(){
      this.tratamientosSeleccionados = [];
      if (this.opcionSeleccion == 1){
        this.listaSeleccionadaAgrupador.forEach(la => {
          this.lstTratamientosProp.forEach(t => {
            if (t.idTratamientoPadre == la.idTratamientoNuevo){
              this.tratamientosSeleccionados.push(t);
            }
          })
        })

        this.$emit("agregarPorAgrupador", this.tratamientosSeleccionados)
        this.hideModal();


      }else if (this.opcionSeleccion == 2){

        this.listaSeleccionadaAgrupador.forEach(agr => {
          this.lstTratamientosProp.forEach(t => {
            if (t.idCategoria == agr.idCategoria){
              this.tratamientosSeleccionados.push(t)
            }
          })

        })

        this.$emit("agregarPorAgrupador", this.tratamientosSeleccionados)
        this.hideModal();

      }else {

        this.listaSeleccionadaAgrupador.forEach(lst => {
          this.tratamientosSeleccionados = this.lstTratamientosProp.filter( t => t.idDenticion === lst.id)
        });

        this.$emit("agregarPorAgrupador", this.tratamientosSeleccionados)
        this.hideModal();
      }
    },
    hideModal() {
      this.$emit("hideModal")
    },
  }
}
</script>

<style scoped>

</style>